import classnames from 'classnames';
import * as React from 'react';
import { useMemo } from 'react';

import { TableFooter } from '../../components/TableFooter';
import styles from '../../Table.module.scss';
import { useTableContext } from '../../TableContext';

type TableFooterProps = {
  footerClassName?: string;
};

function TableFooters<TData>({ footerClassName }: TableFooterProps) {
  const { getTable } = useTableContext<TData>();

  const groups = getTable()?.getFooterGroups() || [];
  const footers = useMemo(
    () =>
      groups.map((footerGroup) => (
        <tr key={footerGroup.id}>
          {footerGroup.headers.map((footer) => (
            <TableFooter footer={footer} key={footer.id} />
          ))}
        </tr>
      )),
    [groups],
  );

  return (
    <tfoot className={classnames(styles.footer, footerClassName)} key="table-footer">
      {footers}
    </tfoot>
  );
}

export { TableFooters };
